import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    const icons = {
      login: 'LogIn',
      update: 'Edit',
      create: 'Plus',
      delete: 'Trash2',
      view: 'Eye'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      login: 'var(--color-primary)',
      update: 'var(--color-accent)',
      create: 'var(--color-success)',
      delete: 'var(--color-error)',
      view: 'var(--color-secondary)'
    };
    return colors?.[type] || 'var(--color-muted-foreground)';
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Proprio ora';
    if (diffMins < 60) return `${diffMins} minuti fa`;
    if (diffHours < 24) return `${diffHours} ore fa`;
    if (diffDays < 7) return `${diffDays} giorni fa`;
    return date?.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
  };

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 hover:bg-muted/50 rounded-lg transition-colors duration-250">
      <div 
        className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full flex-shrink-0"
        style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}
      >
        <Icon 
          name={getActivityIcon(activity?.type)} 
          size={16} 
          color={getActivityColor(activity?.type)} 
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm md:text-base text-foreground font-medium mb-1">
          {activity?.title}
        </p>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
          {activity?.description}
        </p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs text-muted-foreground">
            {formatTime(activity?.timestamp)}
          </span>
          {activity?.user && (
            <>
              <span className="text-xs text-muted-foreground">•</span>
              <div className="flex items-center gap-1">
                <Image 
                  src={activity?.user?.avatar} 
                  alt={activity?.user?.avatarAlt}
                  className="w-4 h-4 rounded-full object-cover"
                />
                <span className="text-xs text-muted-foreground">
                  {activity?.user?.name}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;